import styled from "styled-components";

export const HeaderStyled = styled.header`
  width: 100vw;
  height: 11.8rem;
  border: 0.1rem solid var(--color-grey2);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeaderContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0rem 1.2rem;
  gap: 7rem;
`;
